import { FontSize } from '@store/types/UserStoreSlice.type';
import { Palette } from '@mui/material/styles';
import { adjustFontSize, adjustLineHeight, getTypographyVariants } from '@theme/styleOverrides/typography';

const text = {
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
    textUnderlineOffset: '4px',
  },
};

export const MuiButton = ({ palette, fontSize }: { palette: Palette; fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      ...getTypographyVariants(fontSize).button,
      lineHeight: `${adjustLineHeight(16, fontSize)}px`,
      minWidth: '76px',
      borderRadius: '20px',
      padding: '8px 16px 8px 16px',
    },
    contained: {
      color: palette.button.outlined,
      backgroundColor: palette.button.outlinedDark,
      '&:disabled': {
        color: `${palette.button.containedDisabledText}`,
        backgroundColor: `${palette.button.outlinedDark}30`,
      },
      '&:hover': {
        backgroundColor: `${palette.button.outlinedDark}80`,
      },
    },
    outlined: {
      color: palette.button.outlinedDark,
      border: `1px solid ${palette.button.outlinedDark}`,
      '&:hover': {
        backgroundColor: palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
      },
      '&:disabled': {
        color: `${palette.button.outlinedDark}60`,
        border: `1px solid ${palette.button.outlinedDark}60`,
      },
    },
    text: {
      minWidth: '0px',
      color: palette.button.tertiary,
      '&:hover': {
        ...text,
      },
      '&:focus': {
        backgroundColor: 'transparent',
        textDecoration: 'underline',
        textUnderlineOffset: '4px',
      },
      '&:disabled': {
        color: `${palette.button.tertiary}60`,
      },
    },
    sizeSmall: {
      fontSize: `${adjustFontSize(12, fontSize)}px`,
    },
  },
});
